import styled from 'styled-components';

export const CurvedText = ({
  text,
  objectSize = 120,
  spacing = 12,
  offset = 30,
  overlap = false,
}: any) => {
  const d = objectSize + spacing * 2;
  const r = objectSize / 2 + spacing / 2;
  const CurvedText = styled.p`
    margin-bottom: ${overlap ? `-${r}px` : '0'};
    width: ${d + offset * 2}px;
    height: ${r + offset}px;
    path {
      fill: transparent;
    }
    text {
      font-size: 28px;
      fill: currentColor;
      text-anchor: middle;
    }
  `;

  return (
    <CurvedText className="curved-text">
      <svg viewBox={`0 0 ${d + offset * 2} ${r + offset * 2}`}>
        <path
          d={`M${offset},${r + offset} A${r},${r} 0 0,1 ${d + offset},${
            r + offset
          }`}
          id="curve"
        />
        <text width="500">
          <textPath startOffset="50%" xlinkHref="#curve">
            {text}
          </textPath>
        </text>
      </svg>
    </CurvedText>
  );
};
